import { type ReactElement, type ReactNode } from 'react'
import cn from 'classnames'
import { useSnapshot } from 'valtio'
import { proxyGlobalAuth } from '../../../proxies/proxyGlobalAuth'

interface ButtonProps {
  clickFunction: (event: React.MouseEvent<HTMLButtonElement>) => void
  icon: ReactNode
  text: string
}

function AddEntityButton ({ clickFunction, icon, text }: ButtonProps): ReactElement {
  const { siteTheme: { addEntityButton } } = useSnapshot(proxyGlobalAuth)

  return (
    <button
      onClick={clickFunction}
      type="button"
      className={cn(addEntityButton.classes, 'flex items-center justify-center py-2 px-4 rounded bg-white ')}
    >
      <span className="text-blue-500 mr-2">{icon}</span>
      {text}
    </button>
  )
}

export default AddEntityButton
